export default "__VITE_ASSET__CwD9knYI__"